import "./vto.scss";
import {
	VCol,
	VRow
} from "vuetify/lib";

export default {
	name: "vision",

	props: { vto: Object },

	render() {
		return <VCol>
			<VRow class="text-h3 text-center">
				VISION
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					CORE VALUES
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.coreValues}></div>
				</VCol>
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					CORE FOCUS
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.coreFocus}></div>
				</VCol>
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					10-YEAR TARGET
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.tenYearTarget}></div>
				</VCol>
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					MARKETING STRATEGY
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.marketingStrategy}></div>
				</VCol>
			</VRow>

			<VRow class="vto-section">
				<VCol class="vto-section__header" cols={4}>
					3-YEAR PICTURE
				</VCol>

				<VCol class="vto-section__content" cols={8}>
					<div domPropsInnerHTML={this.vto.threeYearPicture}></div>
				</VCol>
			</VRow>
		</VCol>;
	}
};
